const footerLinks = [
  { label: '媒体聚焦', href: '#media' },
  { label: '移动访问', href: '#app' },
  { label: '热点资讯', href: '#cards' },
  { label: '平台特色', href: '#features' },
  { label: '专题索引', href: '#index' },
  { label: '最新动态', href: '#updates' },
  { label: '热度榜单', href: '#ranking' },
  { label: '常见问题', href: '#faq' },
  { label: '联系我们', href: '#contact' },
];

const partnerPlaceholders = [
  '合作伙伴A', '合作伙伴B', '合作伙伴C', '合作伙伴D',
  '合作伙伴E', '合作伙伴F', '合作伙伴G', '合作伙伴H',
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="text-xl font-heading font-bold text-background-50 block mb-3">
                吃瓜网51
              </span>
              <p className="text-sm text-background-300 leading-relaxed mb-4">
                吃瓜网51官方首页入口，提供安全稳定的网页版与正式版访问。汇集最新吃瓜资源，一站式娱乐资讯聚合平台，让您第一时间了解娱乐圈最新动态。
              </p>
              <div className="flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/10 text-background-200 cursor-pointer">
                  <i className="ri-weibo-line text-sm"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/10 text-background-200 cursor-pointer">
                  <i className="ri-wechat-line text-sm"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/10 text-background-200 cursor-pointer">
                  <i className="ri-video-line text-sm"></i>
                </span>
              </div>
            </div>

            <div>
              <span className="text-sm font-medium text-background-50 block mb-4">快速导航</span>
              <ul className="space-y-2.5">
                {footerLinks.slice(0, 5).map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-background-300 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <span className="text-sm font-medium text-background-50 block mb-4">更多链接</span>
              <ul className="space-y-2.5">
                {footerLinks.slice(5).map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-background-300 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <span className="text-sm font-medium text-background-50 block mb-4">合作伙伴</span>
              <div className="grid grid-cols-2 gap-2">
                {partnerPlaceholders.map((name) => (
                  <span
                    key={name}
                    className="text-xs text-background-400 bg-background-50/5 rounded-lg px-3 py-2 text-center whitespace-nowrap"
                  >
                    {name}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-50/10">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-xs text-background-400">
                &copy; 2026 吃瓜网51官网 - 吃瓜网51官网版与官方首页入口. 版权所有.
              </p>
              <div className="flex items-center gap-4 text-xs text-background-400">
                <span className="cursor-pointer hover:text-background-200 transition-colors duration-200 whitespace-nowrap">隐私政策</span>
                <span className="cursor-pointer hover:text-background-200 transition-colors duration-200 whitespace-nowrap">服务条款</span>
                <span className="cursor-pointer hover:text-background-200 transition-colors duration-200 whitespace-nowrap">免责声明</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}